import UniversalPagination from "./UniversalPagination";
import { LabExam } from '../LabExam';

interface PaginationProps {
  currentPage: number;
  itemsPerPage: number;
  paginate: (pageNumber: number) => void;
  labList: LabExam[]; 
}

function Pagination({ currentPage, itemsPerPage, paginate, labList }: PaginationProps) {
  return (
    <UniversalPagination<LabExam>
      currentPage={currentPage}
      itemsPerPage={itemsPerPage}
      paginate={paginate}
      items={labList}
    />
  );
}

export default Pagination;